import styled from "styled-components";
import { ProgramDescription } from "common/program_selector";
import { FormInfo } from "./RegistrationStyle";

export const PaidProgram = styled.div`
  width: 100%;
  min-height: 60px;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  border: solid 2px #e4e4e4;
  border-radius: 2px;
  margin: 10px 0px 8px;

  & ${ProgramDescription} {
    padding: 0px 18px;
  }

  // mobile
  @media only screen and (max-width: 480px) {
    & ${ProgramDescription} {
      padding-bottom: 6px;
      justify-content: center;
    }
  }
`;

export const ConfirmationCardInfo = styled(FormInfo)`
  margin: 0px;
`;
